<template>
  <div id="branch-employees-table">
    <vs-button
      color="primary"
      type="border"
      class="mb-4 mr-4"
      @click="openAddEmployeePopup"
    >
      <KonturIcon name="PeopleOnePlusIcon" size="16" />
      &thinsp;Добавить сотрудника
    </vs-button>
    <vs-button
      color="primary"
      type="border"
      class="mb-4 mr-4"
      @click="openInvitePopup"
    >
      <KonturIcon name="AttachLinkIcon" size="16" />
      &thinsp;Ссылка-приглашение сотрудников
    </vs-button>
    <vs-button
      color="primary"
      type="border"
      class="mb-4 mr-4"
      @click="downloadVcards"
    >
      <KonturIcon name="NetDownloadIcon" size="16" />
      &thinsp;Скачать QR-коды
    </vs-button>

    <EmptyList
      v-if="hasNoEmployees"
      imgFileName="employee.png"
      title="Сотрудников нет"
    />

    <BranchEmployeesTable v-else :data="currentBranchEmployees" />

    <vs-popup
      title="Ссылка для регистрации"
      :active.sync="popupShareLinkEmployees"
    >
      <vs-input
        v-model="inviteNewToken"
        class="mt-1"
        description-text="Вы можете просто отправить сотрудникам ссылку на регистрацию, они автоматически будут видны в вашем личном кабинете"
      />
      <vs-button
        type="border"
        title="Скопировать ссылку"
        v-clipboard:copy="inviteNewToken"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        >Скопировать ссылку
      </vs-button>
    </vs-popup>

    <vs-popup
      title="Ссылка для регистрации"
      :active.sync="popupInviteNewEmployees"
    >
      <vs-input v-model="inviteNewToken" />
      <vs-button
        v-clipboard:copy="inviteNewToken"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
      >
        Копировать
      </vs-button>
    </vs-popup>

    <vs-popup
      title="Ссылка для приглашения уже зарегистрированных пользователей"
      :active.sync="popupInviteRegisteredEmployees"
    >
      <vs-input v-model="inviteRegisteredToken" />
      <vs-button
        v-clipboard:copy="inviteRegisteredToken"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
      >
        Копировать
      </vs-button>
    </vs-popup>

    <vs-popup title="Скачать QR-коды" :active.sync="popupDownloadVcards">
      <vs-button v-if="!hasNoEmployees" @click="getQrCodes">
        Скачать QR-коды сотрудников </vs-button
      ><br /><br />
      <vs-button @click="goToBranchQr">
        Скачать QR-код общей страницы </vs-button
      ><br />
      <p class="mt-2">
        Скачивание QR-кода для одного сотрудника доступно напротив его имени в
        разделе Сотрудники
      </p>
      <vs-button
        href="https://kontur.ru/lp/market-tips#qrcode"
        @click="gotToPromo"
        type="flat"
        target="_blank"
      >
        Размещение в заведении </vs-button
      ><br /><br />
    </vs-popup>

    <vs-popup
      title="Регистрация сотрудника"
      :active.sync="popupRegisterEmployees"
    >
      <BranchRegisterEmployee :inviteNewToken="inviteNewToken" />
    </vs-popup>
  </div>
</template>

<script>
import { BRANCH_EMPLOYEES_FETCH } from '@/store/action.types'
import BranchRegisterEmployee from './components/BranchRegisterEmployee.vue'
import BranchEmployeesTable from './components/BranchEmployeesTable.vue'
import KonturIcon from '@/components/KonturIcon'
import { FRONTEND_API_URL, API_URL } from '@/common/config'
import { mapGetters } from 'vuex'
import AuthService from '@/common/auth.service'

export default {
  components: {
    BranchRegisterEmployee,
    BranchEmployeesTable,
    KonturIcon
  },
  data() {
    return {
      apiURL: API_URL,
      loaded: false,
      popupRegisterEmployees: false,
      popupInviteRegisteredEmployees: false,
      inviteRegisteredToken: null,
      popupInviteNewEmployees: false,
      popupShareLinkEmployees: false,
      popupDownloadVcards: false,
      inviteNewToken: null
    }
  },
  watch: {
    '$route.params.id': function(id) {
      this.initBranchEmployees(id)
    }
  },
  computed: {
    ...mapGetters(['currentBranchEmployees']),
    hasNoEmployees() {
      return Object.keys(this.currentBranchEmployees).length === 0
    }
  },
  mounted() {
    this.initBranchEmployees(this.$route.params.id)
  },
  methods: {
    async initBranchEmployees(id) {
      this.loaded = false
      this.$vs.loading()
      await this.$store.dispatch(BRANCH_EMPLOYEES_FETCH, id).then(() => {
        // this.users = this.currentBranchEmployees
        this.$vs.loading.close()
        this.loaded = true
      })
    },
    getErrorResponseDescription(response) {
      const error_description = response.data.error
      let notification_text
      if (
        response.status === 422 &&
        error_description === 'company not in organizator'
      ) {
        notification_text =
          'Мы обновили способ авторизации в личном кабинете. Обратитесь в поддержку для восстановления доступа к аккаунту'
      } else {
        notification_text = error_description
      }
      return notification_text
    },
    async getInviteNewEmployees() {
      AuthService.createBranchEmployeeInvitation({
        id: this.$route.params.id
      })
        .then((response) => {
          this.inviteNewToken = `${FRONTEND_API_URL}/confirm/branch/employee/${response.data}`
        })
        .catch(({ response }) => {
          this.$vs.notify({
            title: 'Не удалось создать ссылку-приглашение',
            text: this.getErrorResponseDescription(response)
          })
        })
    },
    async inviteRegisteredEmployee() {
      this.$vs.loading()
      AuthService.createBranchEmployeeInvitation({
        id: this.$route.params.id
      }).then((response) => {
        this.inviteRegisteredToken = `${FRONTEND_API_URL}/confirm/branch/invite/employee/${response.data}`
        this.$vs.loading.close()
        this.popupInviteRegisteredEmployees = true
      })
    },
    async getQrCodes() {
      this.$km_track('QR', 'Download', 'forMockup')
      await AuthService.getQrAll(this.$route.params.id)
    },
    goToBranchQr() {
      this.$km_track('QR', 'Download', 'forCommon')
      this.popupDownloadVcards = false
      this.$router.push({ name: 'branchQr' })
    },
    onCopy() {
      this.$km_track('InviteLink', 'Click', 'CopyLink')
      this.$vs.notify({
        title: 'Успех!',
        text: 'Ссылка скопирована в буфер обмена'
      })
    },
    onError() {
      this.$vs.notify({
        title: 'Failed!',
        text: 'Error in copying text.'
      })
    },
    openAddEmployeePopup() {
      this.$km_track('Staff', 'Click', 'AddEmployee')
      this.popupRegisterEmployees = true
    },
    openInvitePopup() {
      this.$km_track('Staff', 'Click', 'InviteLink')
      this.getInviteNewEmployees()
      this.popupShareLinkEmployees = true
    },
    downloadVcards() {
      this.$km_track('Staff', 'Click', 'QR')
      this.popupDownloadVcards = true
    },
    gotToPromo() {
      this.$km_track('QR', 'Download', 'forPlacement')
    }
  }
}
</script>
<style lang="scss" scoped></style>
